import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Box,
    Image
} from '@chakra-ui/react'

const ModalCriolla = ({ isOpen, onOpen, onClose }) => {
    const handleClick = () => {
        onClose(); // Close the modal first
        window.open('https://bodegascallia.com/criolla/', '_blank');
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                borderRadius={'0px'}
                background={'transparent'}
                width={{ base: '90%', md: '600px' }}
                maxWidth="95%"
                boxShadow="none"
                marginTop="25vh"
            >
                <ModalBody p={0}>
                    <Box
                        cursor="pointer"
                        onClick={handleClick}
                    >
                        <Image
                            src='./img/Callia_Criolla_POPUP_Web.jpg'
                            alt='Callia Criolla'
                            width="100%"
                            height="auto"
                        />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalCriolla